import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import { useThemeProps } from '@mui/material';
import { formatBoolean } from './formatters.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _excluded = ["value"];
var componentRoot = createComponentSlot({
  name: "CinFormatBoolean",
  slot: "Root"
});
/**
 * Formats a value as a boolean
 */

var BooleanFormatter = function BooleanFormatter(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });

  var value = rootProps.value,
      options = _objectWithoutProperties(rootProps, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, formatBoolean(value, _objectSpread2({
    yes: "Yes",
    no: "No"
  }, options)));
};

BooleanFormatter.propTypes = {
  value: propTypes.any
};
var BooleanFormatter$1 = BooleanFormatter;

export { BooleanFormatter$1 as default };
